import { createContext } from "react"

import type { Dispatch, SetStateAction } from "react"

export interface LoadingContextValue {
  isLoading: boolean
  setIsLoading: Dispatch<SetStateAction<boolean>>
}

const LoadingContext = createContext<LoadingContextValue>({
  isLoading: false,
  setIsLoading: () => {},
})

export default LoadingContext
